class CartDrawer extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.activeClass = window.drawerToggleClasses.cartDrawer;
    this.cartIconBubble = document.querySelectorAll('[aria-controls="cartDrawer"]');

    this.options = {
      showCartDrawerUpsell: false,
    };

    if (this?.dataset?.options) {
      const dataOptions = JSON.parse(this.dataset.options);
      this.options = {
        ...this.options,
        ...dataOptions,
      };
    }

    this.listeners = {
      keyup: event => event.code === 'Escape' && this.close(),
      renderCartDrawer: this.renderCartDrawer.bind(this),
      renderContents: this.renderContents.bind(this),
      open: this.open.bind(this),
    };

    this.addEventListener('cart-drawer:render-drawer', this.listeners.renderCartDrawer);
    this.addEventListener('cart-drawer:open', this.listeners.open);
    this.addEventListener('cart-drawer:render-contents', this.listeners.renderContents);
  }

  disconnectedCallback() {
    this.removeEventListener('cart-drawer:render-drawer', this.listeners.renderCartDrawer);
    this.removeEventListener('cart-drawer:open', this.listeners.open);
    this.removeEventListener('cart-drawer:render-contents', this.listeners.renderContents);
  }

  open() {
    const drawer = this.querySelector('#cartDrawer');
    document.body.classList.add(this.activeClass);
    this.cartIconBubble.forEach(button => button.setAttribute('aria-expanded', true));

    // add the eventListener to close on ESC key
    drawer.addEventListener('keyup', this.listeners.keyup);

    trapFocus(drawer);
  }

  close(trigger = null) {
    document.body.classList.remove(this.activeClass);
    this.cartIconBubble.forEach(button => button.setAttribute('aria-expanded', false));

    drawer.removeEventListener('keyup', this.listeners.keyup);

    removeTrapFocus(trigger);
  }

  renderContents(event) {
    let { parsedState } = event.detail || event;

    if (!('sections' in parsedState)) return;

    this.getSectionsToRender().forEach((section) => {
      if (section?.selector) {
        const selector = document.querySelector(section.selector);

        if (selector) {
          selector.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
        }
      }
    });
  }

  async renderCartDrawer() {
    const body = JSON.stringify( {
      sections: this.getSectionsToRender().map(section => section.section),
      sections_url: window.location.pathname,
    });
    const response = await fetch(routes.cart_update_url, {
      ...fetchConfig('javascript'),
      ...{ body },
    });

    const parsedState = await response.json();
    this.renderContents({ detail: { parsedState } });
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        section: 'theme-cart-drawer',
        selector: '[data-cart-drawer]',
      },
      {
        id: 'cart-icon-bubble',
        section: 'theme-cart-icon-bubble',
        selector: '[data-cart-icon-bubble]',
      },
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }
}

if (!customElements.get('cart-drawer')) {
  customElements.define('cart-drawer', CartDrawer);
}
